import * as React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

export default function ConfirmDeleteDialog({ chat, onCancel, onConfirm }) {
    return (
        <Dialog open={Boolean(chat)} onClose={onCancel}>
            <DialogTitle>Delete chat?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    "{chat?.title || "New chat"}" and its messages will be permanently deleted.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>
                <Button color="error" onClick={onConfirm}>Delete</Button>
            </DialogActions>
        </Dialog>
    );
}
